// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 23:07:42

export default {
  "id": "big-bad-ape-2",
  "slug": "big-bad-ape-2",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/8ce2973aeffb49b4beeeaa02463f95b9-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/8ce2973aeffb49b4beeeaa02463f95b9/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Big Bad Ape",
      "description": "In Big Bad Ape, you will play as an unstoppable giant ape. Join this casual battle and experience the exhilaration of destroying a city! Freed from a lab experiment, this furious monster is now unleashed. As this super monster, your job is to destroy everything.",
      "instructions": "Mouse click or tap to play\n",
      "genres": [
        "Casual"
      ],
      "tags": [
        "battlefield",
        "destroy",
        "monster"
      ]
    },
    "zh-CN": {
      "title": "大恶猿",
      "description": "在《大坏猿》中，你将扮演一个势不可挡的巨猿。加入这场休闲战斗，体验摧毁城市的激动！从实验室实验中逃脱，这只愤怒的怪物现在被释放了。作为这位超级怪物，你的任务是摧毁一切。",
      "instructions": "鼠标点击或轻触开始游戏",
      "genres": [
        "休闲"
      ],
      "tags": [
        "战场",
        "摧毁",
        "怪物"
      ]
    },
    "zh-TW": {
      "title": "大惡猿",
      "description": "在《Big Bad Ape》中，您將扮演一隻無敵的巨猿。加入這場隨意戰鬥，體驗摧毀城市的刺激！這頭狂怒的怪物在從實驗室實驗中獲得釋放後，現在已經被釋放入野。作為這頭超級怪物，您的任務就是摧毀一切！",
      "instructions": "滑鼠點擊或觸控玩遊戲",
      "genres": [
        "休闲"
      ],
      "tags": [
        "戰場",
        "毀滅",
        "怪物"
      ]
    },
    "zh-HK": {
      "title": "巨惡猿",
      "description": "在《Big Bad Ape》中，你將扮演一隻無敵的巨猿。加入這場隨意戰鬥，體驗摧毀城市的刺激！從實驗室實驗中釋放，這頭狂怒的怪物現在已被釋放。作為這位超級怪物，你的任務就是摧毀一切！",
      "instructions": "滑鼠點擊或觸控玩遊戲",
      "genres": [
        "隨意"
      ],
      "tags": [
        "戰場",
        "摧毀",
        "怪物"
      ]
    },
    "ja": {
      "title": "ビッグバッドアぺー",
      "description": "ビッグ・バッド・アpäで、無敵の巨大猿としてプレイしましょう。このカジュアルバトルに参加し、都市を破壊する興奮を体験してください。ラボの実験から解放されたこの怒った怪物は今や解放されました。このスーパーモンスターとしてのあなたの仕事は、全てを破壊することです。",
      "instructions": "マウスクリックまたはタップして遊ぶ",
      "genres": [
        "カジュアル"
      ],
      "tags": [
        "バトルフィールド",
        "破壊",
        "モンスター"
      ]
    },
    "ko": {
      "title": "대나무 악곰",
      "description": "Big Bad Ape에서는 불가지부지한 거대한 대원숭이로서를 맡게 됩니다. 이 캐주얼 전투에 참여하고 도시를 파괴하는 열띤 경험을 즐겨보세요! 연구소실험에서 해방된 이 분노의 몬스터는 지금 이제 방출되었습니다. 이 슈퍼 몬스터로서, 당신의 임무는 모든 것이 파괴되는 것입니다.",
      "instructions": "마우스 클릭이나 탭하여 게임 시작",
      "genres": [
        "캐주얼"
      ],
      "tags": [
        "전장",
        "파괴",
        "몬스터"
      ]
    },
    "fr": {
      "title": "Gros Singe Maléfique",
      "description": "Dans Big Bad Ape, vous jouerez en tant qu'une immense gorille invincible. Rejoignez ce combat casual et vivez l'excitation de détruire une ville ! Libéré d'un expérimentation de laboratoire, ce monstre furieux est maintenant libéré. En tant que ce super monstre, votre mission est de détruire tout ce qui se trouve sur votre chemin.",
      "instructions": "Cliquez sur la souris ou appuyez pour jouer",
      "genres": [
        "Accordéon"
      ],
      "tags": [
        "bataille de champ de bataille",
        "détruire",
        "monstre"
      ]
    }
  }
};
